import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import {TranslateService} from '@ngx-translate/core';
import { CKEditor4 } from 'ckeditor4-angular';
import { Subscription } from 'rxjs';
import { WordcountService } from '../../../../wordcount.service';
import { SafeHtml } from '@angular/platform-browser';

declare var decimalInput: any;
declare function activateTab(tabId): any;

@Component({
  selector: 'app-tab',
  templateUrl: './tab.html',
  styleUrls: ['./tab.scss']
})

export class Tab implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public forceSelection = false;
  public shownTabs:string[] = [];
  public tabHeaderContent:string[] = [];
  public tabContent:string[] = [];
  public buttonText:string;
  public selectedTab:string = "";
  public ckeConfig:any;
  public questionText : SafeHtml = "";

  private loadAnswersSubscription : Subscription;

  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService,
    public wordCount: WordcountService
  ) { 
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }
    this.ckeConfig = {
      toolbarGroups: [
        { name: 'styles', groups: [ 'styles' ] },
        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
        { name: 'colors', groups: [ 'colors' ] },
        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
        { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
        { name: 'forms', groups: [ 'forms' ] },
        '/',
        { name: 'links', groups: [ 'links' ] },
        { name: 'insert', groups: [ 'insert' ] },
        '/',
        { name: 'tools', groups: [ 'tools' ] },
        { name: 'others', groups: [ 'others' ] },
        { name: 'about', groups: [ 'about' ] }
      ],
      fullpage : true,
      allowedContent: true,
      removeFormatAttributes :'',
      resize_enabled : false,
      resizable: false
    };

    this.ckeConfig.removeButtons = 'Styles,Format,Strike,Subscript,Superscript,RemoveFormat,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Source,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Redo,Find,Undo,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Link,Unlink,Anchor,Table,Flash,Image,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,About,ExportPdf';

    this.loadAnswersSubscription = this.dataSvc.getLoadTabAnswersEvent().subscribe(()=>{
      this.loadAnswers();

    });
  }

  ngOnInit(): void {
    this.loadAnswers();
  }

  resetVariables(){
    this.forceSelection = false;
    this.shownTabs = [];
    this.tabHeaderContent = [];
    this.tabContent = [];
    this.buttonText= "";;
    this.selectedTab = "";
    this.questionText = "";
       
  }

  loadAnswers() {
    if(this.dataSvc.currentQuestion().Question.QuestionType !== 1024) return;

    this.resetVariables();
    clearInterval();
    //GET QUESTION METADATA FOR TABS - THATS WHERE THE INFO FROM ENETASSESS QUESTION BUILDER IS SET
    //ITS LOTS OF SPLITTING AND INDEXOF BUT DONT WANT TO HAVE TO REDO THE WAY QUESTIONS ARE CREATED
    var tabQuestion = this.dataSvc.currentQuestion().Question;
    if(tabQuestion !== null && tabQuestion !== undefined){

      this.questionText = tabQuestion.QuestionText

          if (this.dataSvc.currentQuestion().Question.Question.WordCount !== null && this.dataSvc.currentQuestion().Question.Question.WordCount !== undefined
          && this.dataSvc.currentQuestion().Question.Question.WordCount > 0) {
          this.wordCount.wordcount = this.dataSvc.currentQuestion().Question.Question.WordCount;
          // setInterval(()=>{
          //   this.wordCount.userWords = this.dataSvc.countAnswersWords();
          // },1000);
        }
        if(this.dataSvc.currentQuestion().Result.Selection.indexOf("%%%ChosenTab") > -1){
          if(tabQuestion.Question.Metadata.indexOf("_ChosenTab=") === -1){
            var first = this.dataSvc.currentQuestion().Result.Selection.indexOf("%%%ChosenTab") + 12;
            var last = this.dataSvc.currentQuestion().Result.Selection.lastIndexOf("%%%");
            var savedTab = this.dataSvc.currentQuestion().Result.Selection.substring(first, last);
            this.dataSvc.currentQuestion().Question.Question.Metadata += this.dataSvc.currentQuestion().Question.Question.Metadata = "_ChosenTab=" + savedTab + "_";
          }
        }

      var tabData = tabQuestion.Question.Metadata.toString();
      if(tabData !== null && tabData !== undefined && tabData !== ""){

        if(tabData.indexOf("###Btn:") > -1){
          var first = tabData.indexOf("###Btn:") + 7;
          var last = tabData.lastIndexOf("###");
          this.buttonText = tabData.substring(first, last);
        }

        var tabHeaders = document.getElementsByClassName("navLi");
            for (var z = 0; z < tabHeaders.length; z++) {
              var element = tabHeaders[z];        
              element.classList.remove("active");                     
          }
          var tabHPanes = document.getElementsByClassName("tab-pane");
            for (var z = 0; z < tabHPanes.length; z++) {
              var element = tabHPanes[z];        
              element.classList.remove("active");                     
              element.classList.remove("show");                     
          }

        //IF TAB HAS ALREADY BEEN SELECTED PREVIOUSLY THEN HIDE THE OTHERS AND ONLY SHOW THE SELECTED INFO
        if(tabData.indexOf("_ChosenTab=") > -1){
          var first = tabData.indexOf("_ChosenTab=") + 11;
          var last = tabData.lastIndexOf("_");
          var savedTab = tabData.substring(first, last);
          
          this.shownTabs.push(savedTab);
          var chosenTabIndex = savedTab.replace("li", "");
          if(tabData.indexOf("***") > -1){
            var tabs = tabData.split("***");
            
            for(var i = 0; i < tabs.length; i++){              
              var tab = tabs[chosenTabIndex];
                this.shownTabs.push("li" + chosenTabIndex);
                if(tab !== null && tab !== undefined){
                  var tabInfo = tab.split("||");
                  if(tabInfo !== null && tabInfo !== undefined) {
                    this.tabHeaderContent.push(tabInfo[0]);
                    this.tabContent.push(tabInfo[1]);
                    //this.cleanTabContent();
                  }
                }
            }            
          }

          var tabPanes = document.getElementsByClassName("tab-pane");
            for (var z = 0; z < tabPanes.length; z++) {
                var element = tabPanes[z];        
                element.classList.remove("active");
                element.classList.remove("show");                        
            } 
            var tabHeaders = document.getElementsByClassName("navLi");
            for (var z = 0; z < tabHeaders.length; z++) {
              var element = tabHeaders[z];        
              element.classList.remove("active");                     
          }
            document.getElementById("tb" + chosenTabIndex).classList.add("active");                  
            var activeLi = document.getElementById("li" + chosenTabIndex);
            if(activeLi !== null && activeLi !== undefined){
              activeLi.classList.add("active");
            }

            if(tabData.indexOf("$$$Force$$$") > -1){
              //this.forceSelection = true;
              tabData = tabData.replace("$$$Force$$$", "");
            }
            else{
              this.forceSelection = false;
            }
        }
        else{          
          //OTHERWISE SHOW ALL TAB RELATED DATA AND POPULATE THE TAB HEADERS AND TAB CONTENTS FOR EACH ONE
          if(tabData.indexOf("$$$Force$$$") > -1){
            this.forceSelection = true;
            tabData = tabData.replace("$$$Force$$$", "");
          }
          else{
            this.forceSelection = false;
          }          
  
          if(tabData.indexOf("***") > -1){
            var tabs = tabData.split("***");
            for(var i = 0; i < tabs.length; i++){
              this.shownTabs.push("li" + i);
              var tab = tabs[i];
              if(tab !== null && tab !== undefined){
                var tabInfo = tab.split("||");
                if(tabInfo !== null && tabInfo !== undefined){
                  this.tabHeaderContent.push(tabInfo[0]);
                  this.tabContent.push(tabInfo[1]);
                  //this.cleanTabContent();
                }
              }
            }
          }

          setTimeout(() => {
            var navLi = document.getElementsByClassName("navLi");
            for (var z = 0; z < navLi.length; z++) {
              var element = navLi[z];        
              element.classList.remove("active");                     
          }
          var tabHPanes = document.getElementsByClassName("tab-pane");
            for (var z = 0; z < tabHPanes.length; z++) {
              var element = tabHPanes[z];        
              element.classList.remove("active");                     
              element.classList.remove("show");                     
          }

          var firstElem = document.getElementsByClassName("navLi")[0];
          if(firstElem !== null && firstElem !== undefined){
            firstElem.classList.add("active");            
          }
          var paneElem = document.getElementsByClassName("tab-pane")[0]
          if(paneElem !== null && paneElem !== undefined){
            paneElem.classList.add("active");
            paneElem.classList.add("show");
          }
          },1000);
          
        }
        }
    }
  }

  cleanTabContent() { 
    for (var i = 0; i < this.tabContent.length; i++) {
      this.tabContent[i] = this.tabContent[i].replace("$$$Force$$$", "");
    }
  }

  openCloseThis(id) {
    //OPERATES THE QUESTION ACCORDION WHICH APPEARS INSIDE THE TAB MODAL
    var content = document.getElementById(id).parentElement;
    var collapse = content.querySelector('.collapse');
    var itag = content.querySelector("i");
    if(collapse.classList.contains('in')){
      collapse.classList.remove('in');
      itag.classList.add("glyphicon-plus");
      itag.classList.remove("glyphicon-minus");
    }
    else{
      collapse.classList.add('in');
      itag.classList.remove("glyphicon-plus");
      itag.classList.add("glyphicon-minus");
    }
  }

  selectTab(){
    //IF FORCE SELECTION IS ENABLED FOR TAB QUESTION, THIS WILL SELECT THE TAB PERMANENTLY
    var cfmMsg = "";
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      if(exisitingLangauge == "en"){
        cfmMsg = "Are you sure you want to to select this tab, you wont be able to change at a later date?";
      }
      else if(exisitingLangauge == "nl"){
        cfmMsg = "Weet u zeker dat u dit tabblad wilt selecteren, u kunt dit later niet wijzigen?";
      }
    }
    else{
      cfmMsg = "Are you sure you want to to select this tab, you wont be able to change at a later date?";
    }
    var cnf = confirm(cfmMsg);
    if(cnf){    
      var ct = (<HTMLInputElement>document.getElementById("hdfChosenTab")).value;
      if(ct == ""){
        ct = "li1";
      }
      this.selectedTab = ct.replace("#tb", "li");
      if(this.selectedTab !== ""){
        this.shownTabs.length = 0;
        this.shownTabs.push(this.selectedTab);
        this.dataSvc.currentQuestion().Question.Question.Metadata += this.dataSvc.currentQuestion().Question.Question.Metadata = "_ChosenTab=" + this.selectedTab + "_";
        this.forceSelection = false;
      }
    }
  }

  saveQuestion(){
    if(this.selectedTab !== null && this.selectedTab !== undefined && this.selectedTab !== ""){

      var answer = this.dataSvc.currentQuestion().Result.Selection;
      if(answer.indexOf("%%%") == -1){
        var answerString = "<p style='display:none;color:white;background:white;font-size:1px;'>%%%ChosenTab" + this.selectedTab.replace("li", "") + "%%%</p>" + this.dataSvc.currentQuestion().Result.Selection;
        this.dataSvc.currentQuestion().Result.Selection = answerString;
      }
      document.getElementById("tabModal").style.display = "none";
      document.getElementById("tabModal").classList.remove("show");
    }
    else{
      document.getElementById("tabModal").style.display = "none";
      document.getElementById("tabModal").classList.remove("show");
    }
  }
  
 
}
